module.exports = __webpack_public_path__ + "img/1726035411362-screenshot-1726035356181.png.9cd9d171.webp";